import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id AA5D11B7-D45D-4505-938E-8BEF8C1A79F0
 * name align-vertical-bottom
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-vertical-bottom.svg
 * tags
 */
export const AlignVerticalBottomIcon = createSvgIcon(<><path d="M22 22H2V20H22V22M10 2H7V18H10V2M17 8H14V18H17V8Z" /></>, 'AlignVerticalBottomIcon');
export default AlignVerticalBottomIcon